import styled from 'styled-components/macro';
import Modal from 'react-modal';
import { Button } from '@noths/shared-components';
import { colour, fontSize } from '@notonthehighstreet/toolkit/utils';
import { mediaQuery } from '../../styles/utils';

export const OverlayCustomStyles = {
  overlay: {
    zIndex: '16000002',
    padding: '15% 20px 0 20px',
    backgroundColor: 'rgba(55, 58, 63, 0.8)',
  },
};

export const ReactModal = styled(Modal)({
  [mediaQuery('tablet')]: {
    height: '311px',
    width: '575px',
    margin: 'auto',
  },
  fontFamily: 'NOTHS2, Helvetica Neue, HelveticaNeue, Arial, sans-serif',
  padding: '0',
  outline: 'none',
  border: 'none',
  borderRadius: '5px',
  borderColor: 'transparent',
  backgroundColor: '#ffffff',
  height: 'auto',
  width: '100%',
  margin: '0 auto',
});

export const MaterialButton = styled(Button)({
  [mediaQuery('tablet')]: {
    width: '150px',
  },
  width: '100%',
  height: '48px',
  padding: '16px 9px',
  borderRadius: '5px',
  border: 'none',
  boxShadow: 'none',
  borderColor: 'transparent',
  background: 'none',
  backgroundColor: '#0ca6d4',
  fontSize: fontSize('m'),
  fontStyle: 'normal',
  fontStretch: 'normal',
  lineHeight: '1',
  letterSpacing: 'normal',
  textAlign: 'center',
});

export const Container = styled.div({
  display: 'flex',
});

export const Overlay = styled.div({
  position: 'absolute',
  top: '35%',
  zIndex: '160',
  backgroundColor: 'rgba(55, 58, 63, 0.8)',
});

export const CopyWrapper = styled.div({
  [mediaQuery('tablet')]: {
    padding: '33px 20px 10px 37px',
  },
  padding: '20px',
  fontSize: fontSize('m'),
  fontWeight: 'lighter',
  fontStyle: 'normal',
  fontStretch: 'normal',
  lineHeight: '1.38',
  letterSpacing: 'normal',
  textAlign: 'left',
  color: '#686868',
});

export const Heading = styled.h3({
  fontFamily: 'NOTHS2, Helvetica Neue, HelveticaNeue, Arial, sans-serif',
  fontSize: '21px',
  fontWeight: 'normal',
  fontStyle: 'normal',
  fontStretch: 'normal',
  lineHeight: 'normal',
  letterSpacing: 'normal',
  textAlign: 'left',
  textTransform: 'uppercase',
  color: colour('blue-chill'),
  margin: '0 0 20px 0',
});

export const GDPRComponents = styled.a({
  fontFamily: 'NOTHS2, Helvetica Neue, HelveticaNeue, Arial, sans-serif',
  color: colour('blue-chill'),
  fontWeight: '600',
  textDecoration: 'none',
});

export const ButtonContainer = styled.span({
  display: 'flex',
  boxSizing: 'border-box',
  flexFlow: 'row-reverse',
  padding: '14px 20px',
  textAlign: 'right',
  width: '100%',
  border: 'none',
  borderRadius: '5px',
  borderBottomLeftRadius: '5px',
  borderBottomRightRadius: '5px',
  alignSelf: 'flex-end',
  backgroundColor: colour('pampas'),
});
